import {request} from '@/utils/request'

export default {
  login(data = {}) {
    return request({
      url: '/sys/user/login',
      method: 'post',
      data
    })
  },
  getUserInfo() {
    return request({
      url: '/sys/user/queryUserMenuList',
      method: 'get'
    })
  },
  getUserCompanys() {
    return request({
      url: '/sys/user/getUserCompanys',
      method: 'get'
    })
  },
  uploadToken(data = {}) {
    return request({
      url: '/sys/getUploadToken',
      method: 'post',
      data
    })
  },

  // 文件添加
  
  uploadFile(data) {
    return request({
      url: '/sys/uploadFile',
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data'  // 这个可能被自动覆盖
      },
      data
    })
  },
}
